var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.611,
    height: 16.61,
    viewBox: "0 0 16.611 16.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2197",
    "data-name": "Group 2197",
    transform: "translate(0 1.186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2196",
    "data-name": "Group 2196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2632",
    "data-name": "Path 2632",
    d: "M13.644,41.256a.593.593,0,0,0-.593.593v5.932a.593.593,0,0,1-.593.593H1.78a.593.593,0,0,1-.593-.593V35.917a.593.593,0,0,1,.593-.593H8.9a.593.593,0,1,0,0-1.186H1.78A1.78,1.78,0,0,0,0,35.917V47.781a1.78,1.78,0,0,0,1.78,1.78H12.458a1.78,1.78,0,0,0,1.78-1.78V41.849A.593.593,0,0,0,13.644,41.256Z",
    transform: "translate(0 -34.137)",
    fill: "#116bef"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2199",
    "data-name": "Group 2199",
    transform: "translate(3.56 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2198",
    "data-name": "Group 2198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2633",
    "data-name": "Path 2633",
    d: "M114.795.669a2.271,2.271,0,0,0-3.212,0l-7.814,7.813a.6.6,0,0,0-.143.232l-1.186,3.559a.593.593,0,0,0,.562.781.6.6,0,0,0,.187-.03l3.559-1.186a.593.593,0,0,0,.232-.144l7.814-7.814A2.271,2.271,0,0,0,114.795.669Zm-.839,2.373-7.712,7.712-2.3.769.767-2.3,7.715-7.712a1.084,1.084,0,1,1,1.534,1.532Z",
    transform: "translate(-102.409 -0.004)",
    fill: "#116bef"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d41f8d4f4faa8d2ec505a547204a0322.svg";
export { ForwardRef as ReactComponent };